
import { defineComponent, watch, reactive, computed, onMounted, ref } from 'vue';
import { userStore } from '@/store/user-store';
import { calendarStore } from '@/store/calendar-store';
import { Form as ValidationForm } from 'vee-validate';
import Message from 'primevue/message';
import Login from '@/components/user/Login.vue';
import OverlayPanel from 'primevue/overlaypanel';

// eslint-disable-next-line
//@ts-ignore
import FormControlInput from '@/components/general/FormControl/Input';
// eslint-disable-next-line
//@ts-ignore
import FormControlTextarea from '@/components/general/FormControl/TextArea';
// eslint-disable-next-line
//@ts-ignore
import FormControlAttributes from '@/components/general/FormControl/Attributes';
// eslint-disable-next-line
//@ts-ignore
import FormControlSlider from '@/components/general/FormControl/Slider';
// eslint-disable-next-line
//@ts-ignore
import FormControlCheckbox from '@/components/general/FormControl/Checkbox.vue';
import { CalendarConfigInterface, MessageInterface } from '@/models/calendar.model';
import calendarRepository from '@/api/calendarRepository';
import { domainStore } from '@/store/domain-store';

export default defineComponent({
  name: 'Attendance',
  components: {
    ValidationForm,
    FormControlInput,
    FormControlTextarea,
    FormControlSlider,
    FormControlAttributes,
    FormControlCheckbox,
    Message,
    OverlayPanel,
    Login,
  },
  props: {
    assignedAttributes: {
      required: false,
      type: Array,
      default: () => [],
    },
    privacyPageUrl: {
      // If not given, use url from endpoint as fallback
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const form = reactive({
      name: '',
      email: '',
      comment: '',
      countAttendees: null,
    });
    const loginOP = ref<any>(null);
    const attributeValuesByName = reactive<any>({});

    const showAttendance = ref<boolean>(false);
    const showForm = ref<boolean>(true);
    //computed
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const isLoggedIn = computed((): boolean => {
      return userStore.isLoggedIn();
    });
    const isLoading = computed((): boolean => {
      return calendarStore.getState().isLoadingContent;
    });
    const attendanceMessage = computed((): MessageInterface | null | undefined => {
      return calendarStore.getState().attendanceMessage;
    });
    const messages = computed((): MessageInterface[] | null => {
      if (attendanceMessage.value) {
        return [
          {
            severity: attendanceMessage.value.severity,
            content: attendanceMessage.value.content,
          },
        ];
      } else return [];
    });
    const calendarConfig = computed((): CalendarConfigInterface => {
      return calendarStore.getState().calendarConfig;
    });
    const isAttendand = computed((): number | undefined => {
      return calendarStore.getState().singleEvent.attendanceid;
    });
    const maxAttendants = computed(() => {
      return calendarStore.getState().singleEvent.max_attendants;
    });
    const totalAttendants = computed(() => {
      return calendarStore.getState().singleEvent.attendance_count_total;
    });
    const dsgvoText = computed(() => {
      let text = 'Ich stimme den Datenschutzbedingungen zu.';
      let dsgvoUrl = props.privacyPageUrl;
      if (!dsgvoUrl || dsgvoUrl == '') {
        dsgvoUrl = calendarStore.getState().singleEvent.privacy_url || '';
      }
      if (dsgvoUrl && dsgvoUrl !== '') {
        text += ' Diese können Sie <a target="_blank" href="' + dsgvoUrl + '">hier</a> einsehen.';
      }
      return text;
    });

    //methods:
    const onValidatedFormField = (fieldValue: any) => {
      // console.log("onValidatedFormField", fieldValue);
      attributeValuesByName[fieldValue.name] = fieldValue.value;
    };

    const onProcessForm = (values: any) => {
      if (values.attendComment) {
        values.comment = values.attendComment;
      }
      calendarStore
        .processForm(values)
        .then(() => {
          showForm.value = false;
        })
        .catch((error: any) => {
          console.log(error.response);
        });
    };
    const resetMessage = () => {
      if (attendanceMessage.value?.content === 'Sie haben sich für diesen Termin bereits angemeldet') {
        showAttendance.value = !showAttendance.value;
      }
      calendarStore.setAttendanceMessage(null);
    };
    const onAttendanceBtnClicked = (ev: any) => {
      if (calendarConfig.value.user_required && !isLoggedIn.value) {
        loginOP.value.show(ev);
      } else {
        showAttendance.value = !showAttendance.value;
      }
    };
    //lifehooks
    onMounted(() => {
      if (userStore.getState().user) {
        form.name = userStore.getState().user!.internal_name;
        form.email = userStore.getState().user!.email;
        calendarStore.getSelfAttendance();
      }
    });
    watch(userStore.getState(), () => {
      // if user is logged in, attendance fields get filled, if he already submitted attendance, he gets response
      if (userStore.getState().user) {
        form.name = userStore.getState().user!.internal_name;
        form.email = userStore.getState().user!.email;
        calendarStore.getSelfAttendance();
      } else {
        form.name = '';
        (form.email = ''), calendarStore.setAttendanceMessage(null);
      }
    });

    // //close attendanceForm on event-change
    watch(
      () => calendarStore.getState().singleEvent,
      (oV, nV) => {
        calendarStore.getSelfAttendance();
        if (oV.id !== nV.id) {
          showAttendance.value = false;
        }
      },
      { deep: true }
    );

    return {
      form,
      loginOP,
      domainid,
      attendanceMessage,
      calendarConfig,
      messages,
      showAttendance,
      maxAttendants,
      totalAttendants,
      isLoading,
      isAttendand,
      showForm,
      isLoggedIn,
      dsgvoText,
      onValidatedFormField,
      onAttendanceBtnClicked,
      onProcessForm,
      resetMessage,
    };
  },
});
